'use client';

import { CustomEventName, GTMConstants, GTMEventKey, sendGTM } from '@fe-cnyes/fe-common-gtm';
import { styled } from '@linaria/react';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
import { memo } from 'react';

type NewsSearchEmptyProps = {
  keyword: string;
};

const View = styled.div`
  max-width: 442px;
  width: 100%;
  margin: 100px auto;
  text-align: center;
`;

const Text = styled.p`
  color: #848d97;
  line-height: 26px;
  margin-top: 30px;
`;

const Keyword = styled.span`
  color: black;
`;

const Redirect = styled(Link)`
  color: #e03f19;

  && {
    text-decoration: underline;
  }
`;

const HOT_NEWS = '熱門時事';

const NewsSearchEmpty: FC<NewsSearchEmptyProps> = ({ keyword }) => {
  // 空值頁面點擊熱門新聞 GTM 事件
  const onClick = () => {
    sendGTM({
      [GTMEventKey.EVENT_NAME]: CustomEventName.CLICK_BUTTON,
      [GTMEventKey.SECTION]: GTMConstants.SECTION_PLACEHOLDER,
      [GTMEventKey.CLICK_ITEM]: HOT_NEWS,
      [GTMEventKey.LABEL]: 'FALSE'
    });
  };

  return (
    <View>
      <Image
        src='/assets/images/empty/news-search.svg'
        alt='news keyword not found'
        width={150}
        height={140}
        unoptimized
      />
      <Text>
        您搜尋的&nbsp;<Keyword>{keyword}&nbsp;</Keyword>
        沒有任何結果可顯示，請嘗試其他關鍵字。
        <br />
        “最即時、熱門的新聞話題，歡迎前往
        <Redirect href='/' onClick={onClick}>
          {HOT_NEWS}
        </Redirect>
        ”
      </Text>
    </View>
  );
};

export default memo(NewsSearchEmpty);
